export default __webpack_public_path__ + "static/media/cartao-credito.c0a0fa05.png";